import { render, staticRenderFns } from "./newMerchant.vue?vue&type=template&id=480fc40e&scoped=true&"
import script from "./newMerchant.vue?vue&type=script&lang=js&"
export * from "./newMerchant.vue?vue&type=script&lang=js&"
import style0 from "./newMerchant.vue?vue&type=style&index=0&id=480fc40e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fc40e",
  null
  
)

export default component.exports